import { BaseMapper } from '@ps/utils';
import { Option } from '@sapphire/result';

import { ParentQuestion } from '../../models/parent-question.model';
import { ParentQuestionDto } from '../dtos/parent-question.dto';

export class ParentQuestionMapper extends BaseMapper<
  ParentQuestionDto,
  ParentQuestion
> {
  public fromDto(dto: ParentQuestionDto): ParentQuestion {
    return {
      qualificationId: dto.qualification_id,
      respondentQuestionId: dto.respondent_question_id,
      desc: dto.question_description,
      questionType: dto.question_type,
      answers: Option.from(dto.answers)
        .unwrapOr([])
        .map((answer) => ({
          id: answer.id,
          name: answer.name,
        })),
    };
  }
}
